import CustomLists from "@/components/elements/CustomLists/CustomLists"
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription"
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft"
import Paragraph from "@/components/elements/Paragraph/Paragraph"
import TitleBar from "@/components/elements/TitleBar/TitleBar"
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent"
const PolyurethaneWaterproofing = () => {
    return (
        <>


            <TitleBar title="Polyurethane Waterproofing"
                linkTitle="Services"
                linkTo="/services" />
            <ImageWithContentLeft
                imageUrl="/images/dummy-img.jpg"
                title="Description"
                content="Polyurethane waterproofing stands as a pinnacle of modern construction technology, offering unparalleled protection against water infiltration and damage to structures. As a versatile and highly effective solution, polyurethane waterproofing has revolutionized the way we safeguard buildings, bridges, tunnels, and other critical infrastructure from the corrosive effects of moisture.

        The Essence of Polyurethane Waterproofing:
        
        Polyurethane waterproofing encompasses a range of advanced materials and application techniques designed to create seamless barriers against water ingress. These innovative solutions leverage the unique properties of polyurethane polymers to deliver exceptional performance in diverse environments and applications. "
            />

            <TitleWithContent title="For What Purpose Are Polyurethane Based Waterproofing Materials Practiced?">
                <CustomLists

                    items={[
                        [
                            "Polyurethane based waterproofing materials are laid over the materials like wooden, ceramic as the top coat. These materials, not only protect waterproofing system but also prevent dust deposition, protect brightness of surface and provide an aesthetic look.",
                            "Similarly, polyurethane based materials are also used for waterproofing of water tanks. Polyurethane based waterproofing materials used in potable water tanks because of resistant to corrosion, provide durability and harmless to human health.",
                            "Polyurethane materials are suitable used in wet damp floor areas from internally and externally. In this sense, we can observe that these materials are also used as grouting mastic and filler."

                        ],
                        [
                            "In addition, polyurethane waterproofing materials are used to fill the gaps and cracks formed in the walls or floors of buildings such as tunnels, bridges, concrete wall. Besides, polyurethane based materials used to stop water leaks by reacting with water in the cracks in these structures serve as an injection system.",
                            "On the other hand, it is possible to observe that polyurethane materials are applied on concrete and cement based surfaces as a floor coating material indoors and outdoors.",
                        ]
                    ]}



                />


            </TitleWithContent>

            <TitleWithContent title="Advantages of Polyurethane Based Waterproofing Materials">
                <CustomLists

                    items={[
                        [
                            "Long-term protection",
                            "High flexibility performance",
                            "Resistance to UV lights and weather conditions",
                            "Highly load carrying capacity",
                            "High resistance to abrasion and impact",
                            "Resistance to mold and fungus,",


                        ],
                        [
                            "Resistance to freezing temperature",
                            "Strong adhesion",
                            "Easy and fast installation,",
                            "Perfect and aesthetic appearance",
                            "Resistance to corrosion",

                        ]
                    ]}



                />


            </TitleWithContent>

            <TitleWithContent title="Applying polyurethane waterproofing products">
                <Paragraph content="Applying polyurethane waterproofing products typically involves several steps to ensure proper adhesion, coverage, and curing. Below is a general guide for applying liquid-applied polyurethane waterproofing membranes:" />



            </TitleWithContent>
            <TitleWithContent title="Tools and Materials Needed:">
                <ListWithDescription
                    items={[
                        {
                            title: "Polyurethane Waterproofing Product: ",
                            content: [
                                "Choose a high-quality polyurethane waterproofing membrane suitable for your specific application and substrate.",
                            ]
                        },
                        {
                            title: "Protective Gear:",
                            content: [
                                "Wear appropriate personal protective equipment, including gloves, safety glasses, and respiratory protection.",
                            ]
                        },
                        {
                            title: "Primer:",
                            content: [
                                "Depending on the substrate and product specifications, you may need a primer to enhance adhesion.",
                            ]
                        },
                        {
                            title: "Cleaning Supplies:",
                            content: [
                                "Ensure the substrate is clean and free of debris, dust, grease, and other contaminants.",
                            ]
                        },
                        {
                            title: "Applicator:",
                            content: [
                                "Use a brush, roller, or spray equipment suitable for applying liquid coatings.",
                            ]
                        }
                    ]}
                />
            </TitleWithContent>


            <TitleWithContent title="Application Steps">
                <ListWithDescription
                    items={[
                        {
                            title: "Surface Preparation: ",
                            content: [
                                "Clean the substrate thoroughly to remove any dirt, oil, grease, or other contaminants. Use a pressure washer, degreaser, or suitable cleaning agent as needed.",
                                "Repair any cracks, holes, or damaged areas on the surface. Allow the repairs to cure completely before proceeding."
                            ]
                        },
                        {
                            title: "Priming (if required):",
                            content: [
                                "Apply a suitable primer to the prepared substrate according to the manufacturer's instructions. Use a brush, roller, or sprayer to achieve even coverage.",
                                "Allow the primer to dry completely before applying the polyurethane waterproofing membrane."
                            ]
                        },
                        {
                            title: "Mixing (if required):",
                            content: [
                                "If the polyurethane waterproofing product requires mixing, follow the manufacturer's instructions carefully.",
                                "Use a clean container and mix thoroughly to ensure uniform consistency."
                            ]
                        },
                        {
                            title: "Application:",
                            content: [
                                "Start by applying the polyurethane waterproofing product along the edges and seams of the substrate using a brush or roller.",
                                "Work in sections, applying the product evenly with overlapping strokes to ensure complete coverage.",
                                "Use a brush or roller to spread the product evenly over the surface, maintaining a consistent thickness.",
                                "Avoid puddling or excessive buildup of the product, as this can affect adhesion and curing.",
                            ]
                        },
                        {
                            title: "Detailing:",
                            content: [
                                "Pay special attention to details such as corners, joints, and penetrations. Use additional layers or reinforcement fabric as needed to ensure watertight seals.",
                                "Apply the polyurethane waterproofing product around pipe penetrations, drains, and other protrusions using a brush or trowel."
                            ]
                        },
                        {
                            title: "Curing:",
                            content: [
                                "Allow the first coat of polyurethane waterproofing membrane to cure according to the manufacturer's instructions. This typically involves waiting for the product to dry to the touch before applying additional coats.",
                                "Apply additional coats as needed to achieve the desired thickness and coverage. Follow the manufacturer's recommended application rates and curing times between coats."
                            ]
                        },
                        {
                            title: "Final Inspection:",
                            content: [
                                "Once the polyurethane waterproofing membrane has cured completely, inspect the surface for any defects, imperfections, or areas that may require additional attention.",
                                "Conduct leak tests or moisture checks, if applicable, to verify the integrity of the waterproofing system."
                            ]
                        },
                        {
                            title: "Clean-Up:",
                            content: [
                                "Clean tools and equipment with water or a suitable solvent according to the manufacturer's instructions.",
                                "Dispose of any leftover product and packaging in accordance with local regulations."
                            ]
                        }
                    ]}
                />
                <Paragraph content="By following these steps and adhering to the manufacturer's instructions, you can achieve effective and long-lasting waterproofing protection with polyurethane products." />
            </TitleWithContent>


        </>
    )
}

export default PolyurethaneWaterproofing